import RenderRouter from '@/routes';
// import { createApp } from '@shopify/app-bridge';
import { NavMenu } from '@shopify/app-bridge-react';
// import { getSessionToken } from '@shopify/app-bridge-utils';
import { AppProvider, Frame } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Toast from './components/common/Toast';
import { config } from './config';
// import customersList from './constants/customerHidePayment';
import esTranslations from '@shopify/polaris/locales/es.json';
import frTranslations from '@shopify/polaris/locales/fr.json';
import itTranslations from '@shopify/polaris/locales/it.json';
import ptTranslations from '@shopify/polaris/locales/pt-PT.json';
import viTranslations from '@shopify/polaris/locales/vi.json';
import { useTranslation } from 'react-i18next';
import { PATH } from './constants/path';
import { Language } from './i18n';
import { apiCaller } from './redux/query';
import slice from './redux/slice';
import { isSkipApiSelector } from './redux/slice/auth.slice';
import { dataSettingsSelector } from './redux/slice/dataSettings.slice';
import welcomeSlice from './redux/slice/welcome.slice';
import hiTranslations from './translation/hi_IN.json';

const navigationLinks: Array<{
  label: string;
  pathname: string;
  url: {
    pathname: string;
    search: string;
  };
}> = [
  {
    label: 'Visitor Analytics',
    pathname: PATH.ANALYTICS.pathname,
    url: PATH.ANALYTICS,
  },
  {
    label: 'Block & Re-director',
    pathname: PATH.BLOCKLIST.pathname,
    url: PATH.BLOCKLIST,
  },
  // {
  //   label: 'Fraud orders analytics',
  //   pathname: PATH.FRAUD_ORDER.pathname,
  //   url: PATH.FRAUD_ORDER,
  // },
  // {
  //   label: 'Block checkout',
  //   pathname: PATH.BLOCKED_CHECKOUT.pathname,
  //   url: PATH.BLOCKED_CHECKOUT,
  // },
  // ...(customersList?.includes(config.shop)
  //   ? [
  //     {
  //       label: 'Checkout Rules',
  //       pathname: PATH.CHECKOUT_RULES.pathname,
  //       url: PATH.CHECKOUT_RULES,
  //     },
  //   ]
  //   : []),
  {
    label: 'Settings',
    pathname: PATH.SETTINGS.pathname,
    url: PATH.SETTINGS,
  },
  // {
  //   label: 'Feedback',
  //   pathname: PATH.FEEDBACK.pathname,
  //   url: PATH.FEEDBACK,
  // },
  {
    label: 'Pricing',
    pathname: PATH.PRICING_PLAN.pathname,
    url: PATH.PRICING_PLAN,
  },
];

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const isSkip = useSelector(isSkipApiSelector);
  const fetchDataSettings = apiCaller.useGetGeneralDetailQuery(undefined, { skip: isSkip });
  const dataSettings = useSelector(dataSettingsSelector);

  // const configApp = {
  //   apiKey: process.env.REACT_APP_APP_ID || '',
  //   host: new URLSearchParams(location.search).get('host') || '',
  //   forceRedirect: process.env.REACT_APP_ENV !== 'dev',
  // };
  // if (isSkip) {
  //   const getToken = async () => {
  //     try {
  //       dispatch(authSlice.actions.handleLoading(true));
  //       const app = createApp(configApp);
  //       const sessionToken = await getSessionToken(app);
  //       dispatch(
  //         authSlice.actions.handleToken({
  //           token: sessionToken,
  //           expiredTime: Date.now() + 60 * 1000,
  //           isLoading: false,
  //         }),
  //       );
  //     } catch (err) {
  //       dispatch(authSlice.actions.handleLoading(false));
  //     }
  //   };
  //   getToken();
  // }

  const languageJson = useMemo(() => {
    const languageMap: { [key: string]: any } = {
      [Language.Hindi]: hiTranslations,
      [Language.Vietnamese]: viTranslations,
      [Language.Portuguese]: ptTranslations,
      [Language.Spanish]: esTranslations,
      [Language.French]: frTranslations,
      [Language.Italian]: itTranslations,
    };

    return languageMap[i18n.language] || enTranslations;
  }, [i18n.language]);

  useEffect(() => {
    if (fetchDataSettings.data) {
      dispatch(
        slice.dataSetting.actions.handleSettings({
          settings: fetchDataSettings.data.settings,
          url: fetchDataSettings.data.url || '',
          summaryStats: fetchDataSettings.data.summaryStats,
          quoteAppInstalled: fetchDataSettings.data.quoteAppInstalled || false,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(fetchDataSettings.data)]);

  useEffect(() => {
    if (dataSettings) {
      if (dataSettings.settings.displayWelcome) {
        dispatch(welcomeSlice.actions.handleChangeWelcomeStep(dataSettings.settings.welcomeStep));
        navigate(PATH.WELCOME);
      }

      if (!dataSettings.settings.displayWelcome && 'welcome' === location.pathname) {
        navigate(PATH.DEFAULT);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSettings?.settings.displayWelcome]);

  useEffect(() => {
    dispatch(slice.dataSetting.actions.handleLoading(fetchDataSettings.isLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataSettings.isLoading]);

  return (
    <AppProvider i18n={languageJson}>
      {config.embedded === '1' ? (
        <>
          <Frame>
            <Toast />
            {fetchDataSettings && fetchDataSettings.data?.settings.isShowDevelopmentPlanPage ? (
              <NavMenu>
                <a
                  href={PATH.CONTACT_TO_USE_DEVELOPMENT_STORE.pathname}
                  rel="home"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(PATH.CONTACT_TO_USE_DEVELOPMENT_STORE);
                  }}
                >
                  Development plan
                </a>
              </NavMenu>
            ) : (
              <>
                <NavMenu>
                  <a
                    href={PATH.DEFAULT.pathname}
                    rel="home"
                    onClick={(e) => {
                      e.preventDefault();
                      if (fetchDataSettings && fetchDataSettings.data?.settings.displayWelcome) {
                        navigate(PATH.WELCOME);
                      } else {
                        navigate(PATH.DEFAULT);
                      }
                    }}
                  >
                    Home
                  </a>
                  {navigationLinks.map((item) => {
                    return (
                      // eslint-disable-next-line jsx-a11y/anchor-is-valid
                      <a
                        id={item.pathname}
                        key={item.pathname}
                        href={item.url.pathname + item.url.search}
                        onClick={(event) => {
                          event.preventDefault();
                          if (fetchDataSettings && fetchDataSettings.data?.settings.displayWelcome) {
                            navigate(PATH.WELCOME);
                          } else {
                            navigate(item.url);
                          }
                        }}
                      >
                        {item.label}
                      </a>
                    );
                  })}
                </NavMenu>
              </>
            )}
            {/* {fetchDataSettings.isLoading ? <SkeletonPage /> : isShowSpecialOffer ? renderSpecialOffer : <RenderRouter />} */}
            {!fetchDataSettings.isLoading && <RenderRouter />}
          </Frame>
        </>
      ) : (
        <Frame>
          <Toast />
          <RenderRouter />
        </Frame>
      )}
    </AppProvider>
  );
}

export default App;
